import { ExplorableItemTypeValue } from '~src/spacesPlatform/models/ContentType';

import { Messages } from '../../codegen/Localize';
import { MetricContentType } from '../../metrics/models/MetricContentType';
import { DatabaseContentType, DataRoleContentType, DatasourceContentType, FlowContentType, LensContentType, ProjectContentType, PublishedConnectionContentType, TableContentType, ViewContentType, WorkbookContentType } from '../../spacesPlatform/models/ContentTypes';

/**
 * Authorizable type
 * NOTE: these have to exactly match TypedIdType in the monolith!
 */
export enum AuthorizableType {
  COLLECTION = 'collection',
  DATABASE = 'database',
  DATABASE_TABLE_TEMPLATE = 'databaseTableTemplate',
  DATAROLE = 'dataRole',
  DATASOURCE = 'datasource',
  FLOW = 'flow',
  LENS = 'lens',
  METRIC = 'metric',
  PROJECT = 'project',
  PROJECT_DATASOURCE_TEMPLATE = 'projectDatasourceTemplate',
  PROJECT_DATA_ROLE_TEMPLATE = 'projectDataRoleTemplate',
  PROJECT_LENS_TEMPLATE = 'projectLensTemplate',
  PROJECT_FLOW_TEMPLATE = 'projectFlowTemplate',
  PROJECT_METRIC_TEMPLATE = 'projectMetricTemplate',
  PROJECT_PUBLISHED_CONNECTION_TEMPLATE = 'projectPublishedConnectionTemplate',
  PROJECT_WORKBOOK_TEMPLATE = 'projectWorkbookTemplate',
  PROJECT_DATABASE_TEMPLATE = 'projectDatabaseTemplate',
  PUBLISHED_CONNECTION = 'virtualConnection',
  TABLE = 'table',
  VIEW = 'view',
  WORKBOOK = 'workbook',
}

const AuthorizableTypeToLabelMap = new Map([
  [AuthorizableType.COLLECTION, Messages.collections],
  [AuthorizableType.DATABASE, Messages.databases],
  [AuthorizableType.DATABASE_TABLE_TEMPLATE, Messages.tables],
  [AuthorizableType.DATAROLE, Messages.dataRoles],
  [AuthorizableType.DATASOURCE, Messages.datasources],
  [AuthorizableType.FLOW, Messages.flows],
  [AuthorizableType.LENS, Messages.lenses],
  [AuthorizableType.METRIC, Messages.metrics],
  [AuthorizableType.PROJECT, Messages.projects],
  [AuthorizableType.PROJECT_DATABASE_TEMPLATE, Messages.databases],
  [AuthorizableType.PROJECT_DATASOURCE_TEMPLATE, Messages.datasources],
  [AuthorizableType.PROJECT_DATA_ROLE_TEMPLATE, Messages.dataRoles],
  [AuthorizableType.PROJECT_LENS_TEMPLATE, Messages.lenses],
  [AuthorizableType.PROJECT_FLOW_TEMPLATE, Messages.flows],
  [AuthorizableType.PROJECT_METRIC_TEMPLATE, Messages.metrics],
  [AuthorizableType.PROJECT_PUBLISHED_CONNECTION_TEMPLATE, Messages.publishedConnections],
  [AuthorizableType.PROJECT_WORKBOOK_TEMPLATE, Messages.workbooks],
  [AuthorizableType.PUBLISHED_CONNECTION, Messages.publishedConnections],
  [AuthorizableType.TABLE, Messages.tables],
  [AuthorizableType.VIEW, Messages.views],
  [AuthorizableType.WORKBOOK, Messages.workbooks],
]);

export function getAuthorizableTypeLabel(authorizableType: AuthorizableType): string {
  return AuthorizableTypeToLabelMap.get(authorizableType)();
}

const AuthorizableTypeMap = new Map([
  [ExplorableItemTypeValue.collection, AuthorizableType.COLLECTION],
  [DatabaseContentType.name, AuthorizableType.DATABASE],
  [DataRoleContentType.name, AuthorizableType.DATAROLE],
  [DatasourceContentType.name, AuthorizableType.DATASOURCE],
  [FlowContentType.name, AuthorizableType.FLOW],
  [LensContentType.name, AuthorizableType.LENS],
  [MetricContentType.name, AuthorizableType.METRIC],
  [ProjectContentType.name, AuthorizableType.PROJECT],
  [PublishedConnectionContentType.name, AuthorizableType.PUBLISHED_CONNECTION],
  [TableContentType.name, AuthorizableType.TABLE],
  [ViewContentType.name, AuthorizableType.VIEW],
  [WorkbookContentType.name, AuthorizableType.WORKBOOK],
]);

export function getAuthorizableType(contentType: string): AuthorizableType {
  return AuthorizableTypeMap.get(contentType);
}

export function isAuthorizableTypeContainer(authorizableType: AuthorizableType): boolean {
  return authorizableType === AuthorizableType.PROJECT || authorizableType === AuthorizableType.DATABASE;
}

export function isAuthorizableTypeCatalog(authorizableType: AuthorizableType): boolean {
  return authorizableType === AuthorizableType.DATABASE || authorizableType === AuthorizableType.TABLE;
}
